import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getFirestore, collection, getDocs } from 'firebase/firestore'

interface CampaignItem {
  id: string
  productName: string
  hasFunnel: boolean
  createdAtSeconds: number
}

export default function FunnelsPage() {
  const navigate = useNavigate()
  const [items, setItems] = useState<CampaignItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    async function load() {
      try {
        const db = getFirestore()
        const snap = await getDocs(collection(db, 'campaigns'))
        const list: CampaignItem[] = []

        snap.forEach(docSnap => {
          const data = docSnap.data() as any
          list.push({
            id: docSnap.id,
            productName: data.briefing?.productName || 'Sem nome',
            hasFunnel: !!(data.funnel?.nodes?.length > 1),
            createdAtSeconds: data.createdAt?.seconds || 0,
          })
        })

        list.sort((a, b) => b.createdAtSeconds - a.createdAtSeconds)
        setItems(list)
      } catch (err: any) {
        setError('Erro ao carregar campanhas: ' + err.message)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400">Carregando campanhas...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto">
        <div className="bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg px-4 py-3">
          {error}
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Funis</h1>
      </div>

      {items.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-64 text-center">
          <p className="text-gray-400 mb-2">Nenhuma campanha criada ainda.</p>
          <p className="text-gray-500 text-sm">Crie uma campanha primeiro para poder montar um funil.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {items.map(item => (
            <div
              key={item.id}
              className="bg-white/5 border border-white/10 rounded-2xl p-5 flex items-center justify-between gap-4"
            >
              <div className="min-w-0">
                <p className="text-white font-semibold truncate">{item.productName}</p>
                <div className="flex items-center gap-2 mt-1">
                  {item.hasFunnel ? (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-400 font-medium">
                      Funil configurado
                    </span>
                  ) : (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-white/10 text-gray-400 font-medium">
                      Sem funil
                    </span>
                  )}
                </div>
              </div>
              <button
                onClick={() => navigate(`/funis/${item.id}`)}
                className="px-4 py-2 rounded-lg text-sm font-semibold text-white flex-shrink-0"
                style={{ background: 'linear-gradient(135deg,#6366f1,#10b981)' }}
              >
                {item.hasFunnel ? 'Editar Funil' : 'Criar Funil'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}